import React, { useCallback, useState } from "react";
import { Button, BootstrapModalForm, Input } from "components/bootstrap";
import usePluginEntities from "hooks/usePluginEntities";
const EMPTY_PARAM_JSON = {
  name: "",
  title: "new title",
  description: "",
  data_type: "any",
  default_value: null,
  optional: false,
  binding: null
};
const EditQueryParameterModal = ({ queryParameters, onChange, queryParameter: initialParameter, embryonic }) => {
  var _a;
  const [showModal, setShowModal] = useState(false);
  const [parameter, setParameter] = useState(initialParameter);
  const [validation, setValidation] = useState({});
  const parameterTypes = usePluginEntities("eventDefinitionQueryParameterTypes");
  const currentTypeDef = (_a = parameterTypes.find((t) => t.type === parameter.type)) != null ? _a : parameterTypes[0];
  const openModal = useCallback(() => {
    setParameter(initialParameter);
    setValidation({});
    setShowModal(true);
  }, [initialParameter]);
  const handleClose = useCallback(() => {
    setParameter(initialParameter);
    setShowModal(false);
  }, [initialParameter]);
  const handleTypeChange = useCallback(
    (e) => {
      var _a2, _b;
      const newType = e.target.value;
      const newTypeDef = parameterTypes.find((t) => t.type === newType);
      if (!newTypeDef) return;
      const newParam = newTypeDef.fromJSON({
        ...EMPTY_PARAM_JSON,
        name: parameter.name,
        title: (_a2 = parameter.title) != null ? _a2 : "new title",
        description: (_b = parameter.description) != null ? _b : "",
        type: newType
      });
      setParameter(newParam);
      setValidation({});
    },
    [parameter, parameterTypes]
  );
  const handleChange = useCallback((key, value) => {
    setParameter((prev) => prev.toBuilder()[key](value).build());
  }, []);
  const handleSave = useCallback(() => {
    if (!currentTypeDef) return;
    const errors = currentTypeDef.validate(parameter);
    setValidation(errors);
    if (Object.values(errors).some(Boolean)) return;
    const newQueryParameters = [...queryParameters];
    const index = queryParameters.findIndex((p) => p.name === initialParameter.name);
    if (index < 0) throw new Error(`Query parameter "${initialParameter.name}" not found`);
    newQueryParameters[index] = parameter.toJSON();
    onChange(newQueryParameters);
    setShowModal(false);
  }, [currentTypeDef, initialParameter.name, onChange, parameter, queryParameters]);
  if (parameterTypes.length === 0) {
    return null;
  }
  const validationState = Object.fromEntries(
    Object.entries(validation).map(([k, v]) => [k, v ? ["error", v] : void 0])
  );
  const EditComponent = currentTypeDef == null ? void 0 : currentTypeDef.editComponent;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "small", bsStyle: embryonic ? "primary" : "info", onClick: openModal }, initialParameter.name, embryonic && ": undeclared"), /* @__PURE__ */ React.createElement(
    BootstrapModalForm,
    {
      show: showModal,
      title: `Declare Query Parameter "${initialParameter.name}"`,
      "data-telemetry-title": "Declare Query Parameter",
      onSubmitForm: handleSave,
      onCancel: handleClose,
      submitButtonText: "Save"
    },
    parameterTypes.length > 1 && /* @__PURE__ */ React.createElement(
      Input,
      {
        id: `parameter-type-${initialParameter.name}`,
        type: "select",
        label: "Type",
        value: parameter.type,
        onChange: handleTypeChange
      },
      parameterTypes.map(({ type, title }) => /* @__PURE__ */ React.createElement("option", { key: type, value: type }, title))
    ),
    EditComponent && /* @__PURE__ */ React.createElement(
      EditComponent,
      {
        parameter,
        onChange: handleChange,
        identifier: initialParameter.name,
        validationState
      }
    )
  ));
};
export default EditQueryParameterModal;
